module.exports = __webpack_public_path__ + "assets/img/fin1.86bdc8d6.png";